import { IMessageProps, Message } from 'cd-eft/components/common/MessageCenter/Message';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import stores from 'cd-eft/models/Stores';
import * as SETAPI from 'cd-eft/services/eftSetApi';

export const getError = async (errorCode, storeName) => {
  const store = stores.AppStore[storeName];
  try {
    const response = await SETAPI.ErrorHandlingController.getErrorHandlingByOriginalErrorCodeUsingGET(errorCode);
    return response.data[0].errorShortDescription!;
  } catch (error) {
    store.setError((error as Error).message);
    return 'Something went wrong. Please try again later.';
  }
};

export const getErrorWithoutStore = async (errorCode) => {
  try {
    const response = await SETAPI.ErrorHandlingController.getErrorHandlingByOriginalErrorCodeUsingGET(errorCode);
    return response.data[0].errorShortDescription!;
  } catch (error) {
    console.error(error);
    return 'Something went wrong. Please try again later.';
  }
};

export const getErrorAsMessageObject = async (errorCode, inputName?, canMute?, callingElement?) => {
  try {
    const response = await SETAPI.ErrorHandlingController.getErrorHandlingByOriginalErrorCodeUsingGET(errorCode);
    const data = response.data[0];
    let severity = 'default';
    let title = '';
    switch (data.errorCategoryCode) {
      case 'ERROR':
        severity = 'error';
        title = 'Error!';
        break;
      case 'WARNING':
        severity = 'warn';
        title = 'Warning!';
        break;
      default:
        title = 'Alert!';
        break;
    }
    const messageProps: IMessageProps = {
      title: title,
      severity: severity as any,
      type: 'notification',
      messageContent: response.data[0].errorShortDescription!,
      infoUrl: response.data[0].url,
      fullErrorCode: response.data[0].errorCode,
      shortErrorCode: errorCode,
      canMute: canMute,
      callingElement: callingElement
    }
    if (inputName && inputName !== '') {
      messageProps.messageContent = `${inputName} ${messageProps.messageContent}`;
    }
    return new Message(messageProps);
  } catch (error) {
    console.error(error);
    const messageProps: IMessageProps = {
      title: 'Error!',
      severity: 'error',
      type: 'notification',
      messageContent: 'Something went wrong. Please try again later.',
      canMute: false,
      callingElement: callingElement
    }
    return new Message(messageProps);
  }
};

export const getErrorsByModuleCode = async (moduleCode: string) => {
  try {
    const response = await SETAPI.ErrorHandlingController.getErrorHandlingByModuleCodeUsingGET(moduleCode);
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getErrorsByErrorCodes = async (collatedString: string) => {
  try {
    const response = await SETAPI.ErrorHandlingController.getErrorHandlingByOriginalErrorCodesUsingGET(collatedString);
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getErrorFromAPIResponse = (error) => {
  if ((error as any).response && (error as any).response.data && (error as any).response.data.errorMessage) {
    if ((error as any).response.data.originalErrorCode) {
      MessageCenter.addError((error as any).response.data.errorMessage, undefined, (error as any).response.data.originalErrorCode);
    }
    else {
      MessageCenter.addError((error as any).response.data.errorMessage);
    }
  } else {
    MessageCenter.addError((error as any).message);
  }
};
